module.exports = __webpack_public_path__ + "static/media/animalsGrid-01.7b3bbbb1.jpg";